import { render, staticRenderFns } from "./UpdateServiceTypeDialog.vue?vue&type=template&id=d5d9cd3e&scoped=true"
import script from "./UpdateServiceTypeDialog.vue?vue&type=script&lang=js"
export * from "./UpdateServiceTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateServiceTypeDialog.vue?vue&type=style&index=0&id=d5d9cd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d9cd3e",
  null
  
)

export default component.exports